<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {api, DataType} from "src/services/api/reallis"
    import {delay, validateEmail, navigate} from "src/components/main/#common/helpers"
    import spinIcon from '../../../../materials/images/spin.svg'
    import {onMount} from "svelte"
    import Alert from 'src/components/main/#common/alert/Alert.svelte'
    import {showAlert} from "src/components/main/#common/alert/store"
    import {isLoggedIn} from "../../../services/auth"
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import uIcon from 'src/components/#assets/u.svg'
    import spirale from 'src/components/#assets/spirale.png'
    import elipse from 'src/components/#assets/elipse.png'

    let email = ''
    let sending = false
    let errorStatus = false
    let errorText = ''
    let loadingIcon = '<img class="loading" src="'+spinIcon+'" alt=""/>'

    async function ForgotPass() {
        if (!validateEmail(email)) {
            errorStatus = true
            errorText = 'Please enter a valid email'
            return
        }

        try {
            sending = true
            errorStatus = false;

            await api.ws.ws1.request({
                data: {
                    agent: "auth",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "auth_sendRequestToResetPassword",
                    params: {
                        "email": email,
                    }
                }
            })

            email = ''

            showAlert.set({
                status: 'success',
                text: 'We have sent you an Email to reset your password.'
            })

            await delay(400)
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            sending = false
        }
    }

    $: if ($isLoggedIn) {
        navigate("/account")
    }
</script>

<svelte:head>
    <title>Recover Password</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="panel-wrapper">
            <div class="container">
                <div class="auth-background"></div>
                <div class="auth-wrapper">
                    <img src="{elipse}" class="elipse" alt="">
                    <img src="{spirale}" class="spirale" alt="">
                    <img src="{uIcon}" class="u-icon" alt="">
                    <Alert />
                    <div class="input-group">
                        <Link to="login" class="back">
                            <img src="{learnMore}" alt="">Back
                        </Link>
                    </div>
                    <div class="input-group">
                        <h1 class="title">Recover Password</h1>
                    </div>
                    <div class="input-group">
                        <input type="email" id="EmailInput" class="form-control field" placeholder="Enter your E-mail"
                            autocomplete="email" bind:value={email}>
                    </div>
                    <div class="text-center">
                        <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                        <button class="btn btn-primary auth-button" class:loading={sending} on:click={ForgotPass}
                            disabled={sending}><span>Next</span></button>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .container {
        position: relative;
    }

    .auth-background {
        background: linear-gradient(220deg, rgba(44, 43, 64, 0.15) 23%, #1E1920 50%);
        filter: blur(200px);
        width: calc(100% - 24px);
        height: 550px;
        position: absolute;
    }

    .auth-wrapper {
        background: #27232C;
        border-radius: 10px;
        border: 2px solid #7B7DB3;
        max-width: 480px;
        margin: 60px auto 150px;
        padding: 40px;
        z-index: 2;
        position: relative;
    }

    .title {
        position: relative;
        color: white;
        line-height: 24px;
        font-size: 16px;
        font-weight: 300;
        margin: 0;
    }

    .auth-wrapper .form-control {
        border: 1px solid #7B7DB3;
        border-radius: 3px;
        box-shadow: none !important;
    }

    .auth-button {
        width: 100%;
        margin-top: 20px;
        padding: 17px 45px !important;
        font-weight: 500;
    }

    .auth-wrapper :global(.alert) {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: left;
        padding: 15px 45px 15px 15px;
    }

    .input-group {
        max-width: 550px;
        margin: 10px auto;
    }

    .auth-wrapper :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 0 0 40px;
        display: table;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    }

    .auth-wrapper :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        vertical-align: top;
        margin-top: 2px;
        transition: .25s;
    }

    .auth-wrapper :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    label {
        max-width: 600px;
        float: left;
        margin: 5px 0;
        color: white;
        font-size: 15px;
        line-height: 30px;
        position: relative;
        bottom: 50px;
    }

    input {
        margin: 5px 0;
    }

    a {
        color: white;
        text-decoration: underline;
        position: center;
    }

    input {
        margin: 5px 0;
    }

    .elipse {
        position: absolute;
        z-index: 2;
        left: -289px;
        top: -63px;
        -webkit-user-drag: none;
    }

    .spirale {
        position: absolute;
        z-index: 2;
        right: -320px;
        top: 180px;
        -webkit-user-drag: none;
    }

    .u-icon {
        position: absolute;
        z-index: 2;
        top: 310px;
        left: -180px;
        -webkit-user-drag: none;
    }

    @media(max-width: 1400px) {
        .spirale {
            right: -250px;
        }
    }

    @media(max-width: 991px) {
        .spirale {
            right: -130px;
        }
    }

    @media(max-width: 767px) {
        section {
            padding: 72px 0 0;
        }

        .spirale,
        .elipse,
        .u-icon {
            display: none;
        }

        .auth-wrapper {
            margin: 20px auto -20px;
            padding: 30px;
        }

        .auth-wrapper .form-control {
            padding: 8px 20px;
            margin: 0;
            font-size: 16px;
        }

        .auth-button {
            padding: 12px 15px !important;
            margin-top: 10px;
        }

        .auth-wrapper :global(.back) {
            margin: 0 0 20px;
        }

        .auth-background {
            height: auto;
        }
    }
</style>
